import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4 bg-black text-white">
        <h1 className="text-6xl md:text-8xl font-bold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">404</h1>
        <h2 className="text-2xl md:text-3xl font-semibold mt-6 mb-4">Page Not Found</h2>
        <p className="text-lg text-gray-400 mb-8 max-w-md">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
        <Link to="/" className="px-8 py-3 bg-gradient-to-r from-orange-500 to-red-600 rounded-full font-semibold text-white transition-transform hover:scale-105">
          Return Home
        </Link>
      </div>
    );
  }